"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ = require(".");

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var linkProps = function linkProps(handleClick) {
  return {
    element: "a",
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      handleClick(e);
    }
  };
};
/**
 * Render a CDK global header to GUS 2.0 standards. Includes the CDK
 * logo and your application name.
 *
 * **Note:** `GlobalHeader` is a presentational component.
 *       For functional Global Header (with IAM, EIS and PIS support), please go through `Global Header (with IAM)
 *
 * ```js
 * <CDKGlobalHeader appName="My App" />
 * ```
 *
 * You can render additional icons on the right-hand side by supplying
 * a `GlobalHeaderIcons` component as the child which contains your icons.
 *
 * For example:
 *
 * ```js
 * <CDKGlobalHeader appName="My App">
 *   <GlobalHeaderIcons>
 *     <GlobalHeaderIcon>settings</GlobalHeaderIcon>
 *     <GlobalHeaderIcon>help</GlobalHeaderIcon>
 *   </GlobalHeaderIcons>
 * </CDKGlobalHeader>
 * ```
 */


var CDKGlobalHeader = function (_React$Component) {
  _inherits(CDKGlobalHeader, _React$Component);

  function CDKGlobalHeader() {
    _classCallCheck(this, CDKGlobalHeader);

    return _possibleConstructorReturn(this, (CDKGlobalHeader.__proto__ || Object.getPrototypeOf(CDKGlobalHeader)).apply(this, arguments));
  }

  _createClass(CDKGlobalHeader, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          appName = _props.appName,
          brand = _props.brand,
          fixed = _props.fixed,
          adjust = _props.adjust,
          menu = _props.menu,
          onClickMenu = _props.onClickMenu,
          onClickLogo = _props.onClickLogo,
          children = _props.children;
      return _react2.default.createElement(_.GlobalHeader, {
        fixed: fixed,
        adjust: adjust
      }, _react2.default.createElement(_.GlobalHeaderSection, {
        align: "start"
      }, menu && _react2.default.createElement(_.GlobalHeaderMenu, null, _react2.default.createElement(_.GlobalHeaderMenuIcon, onClickMenu ? Object.assign({}, linkProps(onClickMenu)) : {})), _react2.default.createElement(_.GlobalHeaderLogo, onClickLogo ? Object.assign({}, linkProps(onClickLogo)) : {}, _react2.default.createElement(_.GlobalHeaderLogoImage, null, _react2.default.createElement(_.CDKLogo, null))), _react2.default.createElement(_.GlobalHeaderLabel, null, _react2.default.createElement(_.GlobalHeaderLabelBrand, null, brand), _react2.default.createElement(_.GlobalHeaderLabelAppName, null, appName))), children);
    }
  }]);

  return CDKGlobalHeader;
}(_react2.default.Component);

CDKGlobalHeader.propTypes = {
  /** Fix the header to the top of the page */
  fixed: _propTypes.bool,

  /** Adjust content to take a fixed toolbar into account */
  adjust: _propTypes.bool,

  /** The brand name */
  brand: _propTypes.string,

  /** The application name */
  appName: _propTypes.string,

  /** Specify a function to be called when the logo is clicked. */
  onClickLogo: _propTypes.func,

  /** Show the hamburger menu icon on mobile */
  menu: _propTypes.bool,

  /** Specify a function to be called when the hamburger menu icon is clicked. */
  onClickMenu: _propTypes.func
};
exports.default = CDKGlobalHeader;